export const getScoreColor = (score: number) => {
  if (score >= 70) return 'text-emerald-600';
  if (score >= 50) return 'text-amber-500';
  return 'text-rose-500';
};

export const getBarScoreColor = (score: number) => {
  if (score >= 70) return '#5EA500';
  if (score >= 50) return '#FF8904';
  return 'oklch(64.5% 0.246 16.439)';
};
